interface CallsIconProps {
  className?: string;
}

/**
 * Handset glyph for the Calls nav item.
 *
 * Separate from `PhoneIcon` on purpose. That one is an app-icon treatment: a green
 * gradient rounded square with a white handset on top, which is the right look for the
 * call/text action buttons on a prospect's About panel, sitting beside the SMS and
 * social brand icons. Shrunk to a 20px nav slot the square backplate is all you see,
 * and because its fills are hardcoded it cannot follow the nav's active colour the way
 * every sibling icon does.
 *
 * This matches the nav convention instead: 20x20 viewBox, glyph only, `currentColor`.
 */
export const CallsIcon = ({ className }: CallsIconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.87 3.2a1.46 1.46 0 0 0-2.06-.29L3.35 4.03C1.51 5.47 2.4 9.2 6.1 12.9c3.7 3.7 7.43 4.59 8.87 2.75l1.12-1.46a1.46 1.46 0 0 0-.29-2.06l-2.33-1.7a1.46 1.46 0 0 0-1.3-.21l-1.9.63a.73.73 0 0 1-.7-.15 12.1 12.1 0 0 1-2.35-2.35.73.73 0 0 1-.15-.7l.63-1.9a1.46 1.46 0 0 0-.21-1.3L6.87 3.2Z"
      fill="currentColor"
    />
  </svg>
);
